import { CustomText, TextAlign } from './CustomText';
import { DialogController } from './DialogController';
import { SimpleButton } from './SimpleButton';

export class Dialog extends createjs.Container {
    width: number;
    height: number;
    static instance: Dialog;
    protected fontColor: string = '#777777';
    protected frameShape: createjs.Shape;

    protected contentsContainer: createjs.Container;
    protected backgroundContainer: createjs.Container;
    protected frameColor0 = '#d3d3d3';
    protected frameColor1 = '#ffffff';
    protected bgColor = 'rgba(0,0,0,0.9)';
    protected lineColor = '#ffffff';
    protected radius = 6;
    protected paddingBottom: number = 18;
    protected lineThick = 2;
    protected bgAlpha: number = 1;
    private beforeCloseHandler: Function;
    private afterCloseHandler: Function;
    protected buttonWidth: number = 120;
    protected buttonHeiht: number = 60;
    protected buttonMargin: number = 10;
    constructor(width: number, height: number) {
        super();
        this.width = width;
        this.height = height;
        this.mouseEnabled = true;
        this.on('mouseover', () => { });

        //背景
        this.frameShape = new createjs.Shape();
        this.backgroundContainer = new createjs.Container();
        this.contentsContainer = new createjs.Container();
        this.addChild(this.frameShape, this.backgroundContainer, this.contentsContainer);

        this.setWindowSize(this.width, this.height);
    }

    /**
     * ウィンドウサイズを設定
     * @param width
     * @param height
     * @param bgAlpha
     */
    setWindowSize(width: number, height: number) {
        // this.background.graphics.clear();
        // this.background.graphics.beginFill(this.bgColor).drawRect(0, 0, this.width, this.height);
        this.frameShape.graphics.clear();
        this.frameShape.graphics.beginFill(this.bgColor).beginStroke(this.lineColor).setStrokeStyle(3).drawRoundRect(0, 0, this.width, this.height, 8);
        this.width = width;
        this.height = height;
    }


    setBg(sprite: createjs.Sprite) {
        this.backgroundContainer.addChild(sprite);
    }

    close = (): void => {
        if (this.beforeCloseHandler) {
            this.beforeCloseHandler();
        }

        DialogController.instance.hideDialog(this);

        if (this.afterCloseHandler) {
            this.afterCloseHandler();
        }
    }

    /**
     * ダイアログを閉じる直前に処理する
     * @param func
     */
    setBeforeClose(func: Function) {
        this.beforeCloseHandler = func;
    }
    /**
     * ダイアログ閉じた後に処理する
     * @param func
     */
    setAfterClose(func: Function) {
        this.afterCloseHandler = func;
    }

    /**
     * 中身の追加
     * @param contents
     */
    addContents(...contents: createjs.DisplayObject[]): void {
        contents.forEach(content => {
            this.contentsContainer.addChild(content);
        })
    }

    removeContents(...contents: createjs.DisplayObject[]): void {
        contents.forEach(content => {
            this.contentsContainer.removeChild(content);
        })
    }

    removeAllContents() {
        this.contentsContainer.removeAllChildren();
    }

    show() {
        this.visible = true;
    }

    hide() {
        this.visible = false;
    }


    getDisplayObject(): createjs.DisplayObject {
        return this;
    }
    makeButton(str: string) {
        // const txtStr = new CustomText(str,null,'#FFF','center');
        // const textWidth = txtStr.getBounds().width;
        const btnShape = new createjs.Shape;
        btnShape.graphics.setStrokeStyle(4).beginStroke('#FFF').beginFill('#000').drawRoundRect(0, 0, this.buttonWidth, this.buttonHeiht, 6);
        const btnText = new CustomText(str, 24, '#FFF', 'center', 'middle');
        const container = new createjs.Container();
        container.addChild(btnShape, btnText);
        btnText.x = this.buttonWidth / 2;
        btnText.y = this.buttonHeiht / 2;
        const btn = new SimpleButton(container);
        return btn
    }

}


export class ErrorDialog extends Dialog {
    messageText: CustomText;
    titleText: CustomText;
    lineMargin: number = 20;
    btn_ok: SimpleButton;
    constructor() {
        super(500, 300);
        this.titleText = new CustomText("", 24, "#FFF", "center", "bottom");
        this.titleText.x = this.width / 2;
        this.titleText.y = 34;
        const line = new createjs.Shape();
        line.graphics.beginStroke(this.lineColor)
            .setStrokeStyle(2)
            .moveTo(this.lineMargin, this.titleText.y + 10)
            .lineTo(this.width - this.lineMargin, this.titleText.y + 10);


        this.messageText = new CustomText("", 24, "#FFF", "center", "top", false, true, this.width - 40);

        this.messageText.x = this.width / 2;
        this.messageText.y = this.titleText.y + 30;
        // this.messageText.y = this.lineMargin;

        this.addChild(line);
        this.addContents(this.titleText);
        this.addContents(this.messageText);

        this.btn_ok = this.makeButton('OK');
        this.btn_ok.x = (this.width - this.buttonWidth) / 2;
        this.btn_ok.y = this.height - this.buttonHeiht - 30;
        this.addContents(this.btn_ok);
        this.btn_ok.setFunc('click', () => { this.close() });
    }
    setMessage(title: string, message: string) {
        this.titleText.setText(title);
        this.messageText.setText(message);
        // this.messageText.y = (this.height - this.messageText.getBounds().height) / 2;
    }
}


export class MessageDialog extends Dialog {
    messageText: CustomText;
    titleText: CustomText;
    lineMargin: number = 20;
    constructor() {
        super(500, 150);
        this.titleText = new CustomText("", 30, "#FFF", "center", "middle");
        this.titleText.x = this.width / 2;
        this.titleText.y = 34;
        const line = new createjs.Shape();
        // line.graphics.beginStroke(this.lineColor).moveTo(this.lineMargin, this.titleText.y + 10).lineTo(this.width - this.lineMargin, this.titleText.y + 10);
        line.graphics
            .setStrokeStyle(2)
            .beginStroke(this.lineColor)
            .moveTo(this.lineMargin, this.titleText.y + this.lineMargin * 2)
            .lineTo(this.width - this.lineMargin, this.titleText.y + this.lineMargin * 2);

        this.messageText = new CustomText("", 24, "#FFF", "center", "top", false, true, this.width - 40);

        this.messageText.x = this.width / 2;
        // this.messageText.y = this.titleText.y + this.lineMargin * 3;
        this.messageText.y = this.lineMargin;


        this.addContents(this.messageText);
    }
    setMessage(title: string, message: string) {
        this.titleText.setText(title);
        this.messageText.setText(message);
        this.messageText.y = (this.height - this.messageText.getBounds().height) / 2;

    }
}

export class ButtonDialog extends Dialog {
    messageText: CustomText;
    titleText: CustomText;
    lineMargin: number = 20;
    btn_yes: SimpleButton;
    btn_no: SimpleButton;
    buttonWidth: number = 120;
    buttonHeiht: number = 60;
    buttonMargin: number = 10;
    constructor(messageStr: string, yesStr: string, noStr: string) {
        super(500, 200);
        this.titleText = new CustomText("", 32, "#FFF", "center", "middle");
        this.titleText.x = this.width / 2;
        this.titleText.y = 34;
        const line = new createjs.Shape();
        // line.graphics.beginStroke(this.lineColor).moveTo(this.lineMargin, this.titleText.y + 10).lineTo(this.width - this.lineMargin, this.titleText.y + 10);
        line.graphics
            .setStrokeStyle(2)
            .beginStroke(this.lineColor)
            .moveTo(this.lineMargin, this.titleText.y + this.lineMargin * 2)
            .lineTo(this.width - this.lineMargin, this.titleText.y + this.lineMargin * 2);

        this.messageText = new CustomText(messageStr, 30, "#FFF", "center", "top", false, true, this.width - 40);

        this.messageText.x = this.width / 2;
        // this.messageText.y = this.titleText.y + this.lineMargin * 3;
        this.messageText.y = this.lineMargin;

        const messageHeight = this.messageText.getBounds().height;

        this.addContents(this.messageText);

        this.btn_yes = this.makeButton(yesStr);
        this.btn_no = this.makeButton(noStr);
        this.btn_yes.y = this.btn_no.y = this.height - this.buttonHeiht - this.lineMargin;

        this.btn_yes.x = this.width / 2 - this.buttonWidth - this.buttonMargin;
        this.btn_no.x = this.width / 2 + this.buttonMargin;
        this.addContents(this.btn_yes);
        this.addContents(this.btn_no);


        // this.btn_yes.x = 
    }



    setMessage(title: string, message: string) {
        this.titleText.setText(title);
        this.messageText.setText(message);
        this.messageText.y = (this.height - this.messageText.getBounds().height) / 2;
    }
}